export default __webpack_public_path__ + "static/media/badge.a507266f.svg";